<template>
  <div class="c-main">
    <div class="c-nav">
      <span class="c-nav-title">快捷登录</span>
    </div>
    <div class="c-login-box" v-if="loginState === 1">
      <i class="loading el-icon-loading"></i>
      <span class="loading-text">登录中，请稍后……</span>
    </div>
    <div class="c-login-box" v-if="loginState === 2">
      <span class="err-msg">通知: 登录凭证校验异常，认证无效</span>
    </div>
    <div class="c-login-box" v-if="loginState === 3">
      <span class="err-msg">通知: {{ errMsg }}</span>
    </div>
  </div>
</template>
<script>
export default {
  components: {

  },
  data () {
    return {
      loginState: 1,
      errMsg: null
    }
  },
  methods: {
    cloudLogin (code) {
      const _this = this
      const openLoading = _this.openLoading()

      var params = new URLSearchParams()
      params.append('grant_type', 'password')
      params.append('login_mode', 'ceppea_cloud_login')
      params.append('code', code)
      _this.$api.account.login(params)
        .then(data => {
          const saveParam = {
            token: data.access_token,
            token_type: data.token_type,
            refresh_token: data.refresh_token,
            expires_in: data.expires_in,
            issued: data['.issued'],
            expires: data['.expires'],
            role: 'user',
            rememberClient: false
          }
          _this.$store.commit('ADD_ACCOUNT', saveParam)
          const fellWarn = {
            isDisplayed: false
          }
          localStorage.setItem('FeeWarn', JSON.stringify(fellWarn))
          _this.$router.push({ path: '/meetingList', query: { site: 'cloud' } })
          openLoading.close()
        }).catch(err => {
          if (err.data.error && err.data.error === 'invalid_grant') {
            this.loginState = 3
            _this.errMsg = err.data.error_description
          }
          openLoading.close()
          return err
        })
    }
  },
  created () {
    if (this.$route.query.code) {
      this.cloudLogin(this.$route.query.code)
    } else {
      this.loginState = 2
    }
  }
}
</script>
<style>
.c-main {
  width: 100%;
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .c-nav {
    width: 100%;
    height: 56px;
    padding: 0px 15px;
    box-sizing: border-box;
    border-width: 0 0 1px;
    border-bottom: 1px solid #e2e8f0;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }
}
@media screen and (min-width: 768px) {
  .c-nav {
    width: 100%;
    height: 56px;
    padding: 0px 20%;
    box-sizing: border-box;
    border-width: 0 0 1px;
    border-bottom: 1px solid #e2e8f0;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }
}
.c-nav .c-nav-title {
  font-weight: 700;
  font-size: 20px;
}
.c-login-box {
  width: 100%;
  padding: 90px 0px;
  box-sizing: border-box;
  border-width: 0 0 1px;
  border-bottom: 1px solid #e2e8f0;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
.c-login-box .loading {
  font-size: 32px;
  color: #409eff;
}
.c-login-box .loading-text {
  margin-top: 20px;
  font-size: 14px;
  color: #409eff;
}
.c-login-box .err-msg {
  color: red;
}
</style>
